export enum DataType {
  DIMENSION = 'dimension',
  FACT = 'fact',
  FILTER = 'filter'
}
